import { Injectable, inject } from '@angular/core';
import { UsersService } from '../users.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  assignProcessPartners,
  assignProcessPartnersFailure,
  assignProcessPartnersSuccess,
  assignSurveyPoints,
  assignSurveyPointsFailure,
  assignSurveyPointsSuccess,
  loadUserById,
  loadUserByIdFailure,
  loadUserByIdSuccess,
  loadUsers,
  loadUsersFailure,
  loadUsersSuccess,
  updateUser,
  updateUserFailure,
  updateUserSuccess,
} from './users.actions';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class UsersEffects {
  private readonly actions$ = inject(Actions);
  private readonly usersService = inject(UsersService);

  public readonly loadUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUsers),
      switchMap(() =>
        this.usersService.getUsers().pipe(
          map((users) =>
            loadUsersSuccess({
              users,
              loading: false,
              savingLoading: false,
              assignmentLoading: false,
              selectedUser: null,
              error: null,
            })
          ),
          catchError((error) => of(loadUsersFailure({ error, loading: false })))
        )
      )
    )
  );
  public readonly loadUserById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserById),
      switchMap(({ id }) =>
        this.usersService.getUserById(id).pipe(
          map((user) => loadUserByIdSuccess({ user })),
          catchError((error) => of(loadUserByIdFailure({ error })))
        )
      )
    )
  );
  public readonly updateUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateUser),
      switchMap(({ userId, countryId, changes }) =>
        this.usersService.updateUser(userId, countryId, changes).pipe(
          map((user) => updateUserSuccess({ user })),
          catchError((error) => of(updateUserFailure({ error })))
        )
      )
    )
  );

  public readonly assignProcessPartners$ = createEffect(() =>
    this.actions$.pipe(
      ofType(assignProcessPartners),
      switchMap(({ userId, countryId, processPartners }) =>
        this.usersService
          .assignProcessPartners(userId, countryId, processPartners)
          .pipe(
            map((user) => assignProcessPartnersSuccess({ user })),
            catchError((error) => of(assignProcessPartnersFailure({ error })))
          )
      )
    )
  );

  public readonly assignSurveyPoints$ = createEffect(() =>
    this.actions$.pipe(
      ofType(assignSurveyPoints),
      switchMap(({ userId, countryId, surveyPointIds }) =>
        this.usersService
          .assignSurveyPoints(userId, countryId, surveyPointIds)
          .pipe(
            map((user) => assignSurveyPointsSuccess({ user })),
            catchError((error) => of(assignSurveyPointsFailure({ error })))
          )
      )
    )
  );
}
